import { FC } from "react"
import { useSearchParams } from "react-router-dom"
import { useFetchSubscriptionConfigsQuery } from "../../../../redux/queries"
import { Brand } from "../../../../types"
import BrandAutocomplete from "../../brand-autocomplete"
import SubscriptionConfigTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigSubscription: FC<Props> = ({ brands }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedBrandId = searchParams.get("brand_id") ?? ""

  const setSelectedBrandId = (id: string) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      if (id) next.set("brand_id", id)
      else next.delete("brand_id")
      return next
    })
  }

  const { data, isFetching } = useFetchSubscriptionConfigsQuery({
    brand_id: selectedBrandId
  })

  return (
    <div>
      <BrandAutocomplete
        brands={brands}
        selected={selectedBrandId}
        hideLabel
        onChange={setSelectedBrandId}
      />

      <div className="pt-6">
        <SubscriptionConfigTable
          data={data ?? []}
          brands={brands}
          isFetching={isFetching}
        />
      </div>
    </div>
  )
}

export default ConfigSubscription
